import { action, makeObservable, observable } from 'mobx'

export default class EditableTextFieldStore {
  @observable public draftValue: string
  @observable public isInEditingMode: boolean = false

  public constructor(
    value: string,
    private readonly onChange: (newValue: string) => void,
  ) {
    this.setDraftValue(value)
    makeObservable(this)
  }

  @action.bound
  public setDraftValue(value: string) {
    this.draftValue = value
    this.exitFromEditingMode()
  }

  @action.bound
  public setToEditingMode() {
    this.isInEditingMode = true
  }

  @action.bound
  public exitFromEditingMode() {
    this.isInEditingMode = false
  }

  @action.bound
  public updateDraftValue(newValue: string) {
    if (!newValue) {
      return
    }

    this.draftValue = newValue
  }

  @action.bound
  public applyChange() {
    this.exitFromEditingMode()
    this.onChange(this.draftValue)
  }
}
